export interface IsAllowedArgs {
	is: {
		isAdmin: boolean
		roles: Array<string>
	}
	should: {
		isAdminAllowed?: boolean
		allowed: string
	}
}

export default function isAllowed({
	is: { isAdmin, roles = [] },
	should: { isAdminAllowed = true, allowed = 'NA' },
}: IsAllowedArgs) {
	if (isAdminAllowed && isAdmin) {
		return true
	}

	if (allowed.includes('.*')) {
		const regex = new RegExp(`^${allowed.replace('.*', '\\..*')}`, 'gi') //new RegExp(`^advertisers\\..*`, 'gi')

		return roles.some((role) => regex.test(role))
	}

	return roles.includes(allowed)
}
